import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Box, Hidden } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import FilterView from './FilterView'
import { PlaceBlackIcon, HomeIcon, RisedHandIcon, TuneWhiteIcon, StoreIcon } from '../../components/icons';
import CustomizedCircularProgress from '../../components/CircularProgress'
import ButtonCustom from '../../components/ButtonCustom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';

const heightCoverItem = 200
const heightItem = 350;
const styles = theme => ({
    container: {
        position: 'relative',
    },
    list:{
        marginTop: theme.spacing(1)
    },
    handIcon: {
        height: 35,
    },
    midHeader:{
        position: 'absolute',
        top: theme.spacing(0),
        right: theme.spacing(2),
    },
    button_Filter: {
        marginRight: theme.spacing(2),
        boxShadow: 'none',
        opacity: 1,
        cursor: "pointer",
        '&:hover': {
            opacity: 0.5,
        },
    },
    stores: {
        padding: theme.spacing(3),
        "&:hover": {
            cursor: 'pointer',
        },
    },
    item_store: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        padding: '15px 10px',
        height: '100%',
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.background.card,
    },
    img: {
        height: theme.spacing(10),
    }
});

function OnlineShopView(props){
    const { classes, t, stores, showLoading, hasMore, showLoadMore, onOpenFilter, onShowDetail } = props;
    return (
        <Container>
            <Grid xs={12} item className={classes.container}>
                <Grid xs={12} item container>
                    <Typo mg_left_xl variant='h2' light>{t('online_shop_title')}&nbsp;</Typo>
                </Grid>
                {showLoading&& <CustomizedCircularProgress />}
                <Grid xs={12} item className={classes.list}>
                    <InfiniteScroll
                        dataLength={stores.length} //This is important field to render the next data
                        next={props.handleLoadMore}
                        hasMore={hasMore}
                        loader={showLoadMore? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                    >
                        <Grid xs={12} item container className={classes.list}>
                            {stores.map((item, index) => (
                                <OnlineShopItem key={index} item = {item} classes={classes} onShowDetail={onShowDetail}/>
                            ))}
                        </Grid>
                    </InfiniteScroll>
                </Grid>
                {!showLoading && <Grid item container className={classes.midHeader} direction='row' justify='flex-end' alignItems='center'>
                    <Grid item className={classes.button_Filter} onClick={onOpenFilter}>
                        <TuneWhiteIcon/>
                    </Grid>
                </Grid>}
            </Grid>
        </Container>
    );
}
function OnlineShopItem(props){
    const {item, classes, onShowDetail} = props;
    var listImages = dataUtil.getImageByUsageType(item.creatives, usage_type.merchants_image);
    let img = '';
    if(listImages && listImages.length > 0){
        img = listImages[0].uri;
    }
    return (
        <Grid item xs={12} sm={6} md={4} className={classes.stores} onClick={()=>onShowDetail(item)}>
            <Grid item xs={12} container className={classes.item_store}>
                <Grid item xs={3}>
                    <Box style={{textAlign: 'center'}}>
                        {img ? <img src={img} alt={item.name ? item.name : 'Image Shop'} className={classes.img}></img> 
                        : <div className={classes.img}>
                            <StoreIcon style={{fontSize: 30}}/>
                        </div>}
                    </Box>
                </Grid>
                <Grid item xs={9}>
                    <Typo variant='subtitle2'>{item.name ? item.name : ""}</Typo>
                    <Typo>{item.locations && item.locations.length > 0 ? item.locations[0].address_line_1 : null}</Typo>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default withStyles(styles)(withTranslation()(OnlineShopView));